export const BallotDecisionConstants = {
  SVT_WITHDRAW: 'Withdraw',
  SVT_RECONFIRM: 'Reconfirm',
  SVT_REVISE: 'Revise',
  DEFAULT: '—'
};
